import { usePhotographer } from "views/photographer/context"
import useRouter from "hooks/use-router"
import { useEffect, useState } from "react"
import { useSession } from "contexts/session-context"
import { Photos } from "views/photographer/context/types"
import Carrousel from "views/photographer/components/carrousel"
import Button from "components/button"
import { Link } from "react-router-dom"
import LazyLoad from 'react-lazyload';
import useGuard from "views/photographer/components/hooks/useGuard"
import useMainClass from "hooks/use-main-cass"
import BottomArrow from "components/icon/bottom-arrow"
import styles from "./styles.module.scss"
import { ContinueCardStart, DescriptionCardStart, DescriptionsCardCarrouselStart, DivCardCarrouselStart, DivCardStart, DivTitleStart, ImgCardCarrouselStart, ImgCardStart, TitleStart } from "./custom.style"

const Container = ({ children, title = 'FOTOS CARTA BLANCA' }: { children: React.ReactNode, title?: string }) => (
  <section className="flex flex-col gap-6">
    <div className='w-screen max-w-7xl z-1 flex flex-col gap-6 flex-1 items-center'>
      <DivTitleStart className="flex items-center px-10 w-screen py-5">
        <TitleStart className="flex-grow  max-w-full">{title}</TitleStart>
      </DivTitleStart>
      {children}
    </div>
  </section>
)

function Start() {
  const [{ user }] = useSession()
  const [{ photos }] = usePhotographer()
  const { query, push, pathname, search } = useRouter()
  const [myPhotos, setMyPhotos] = useState<Photos[] | null>(null)
  useMainClass('album__multimedia__profile')
  useGuard()

  useEffect(() => {
    const myPhotos = photos?.filter((photo) => photo?.profileId === user?.id)
    if (myPhotos?.length < 1 && pathname + search !== '/photographer/start') return push('/photographer/upload')
    setMyPhotos(myPhotos)
  }, [photos])

  const handleShare = async (url: string) => {
    const file = await fetch(url).then((r) => r.blob())
    const fileToShare = new File([file], 'carta-blanca.png', { type: 'image/png' })
    window.navigator.share({
      files: [fileToShare],
      title: 'Carta Blanca',
      text: `¡Hola! Les comparto mi creación #fotografocartero.`,
      url: `${URL_BASE}${process.env.PUBLIC_URL}/photographer/start`
    });
  }

  if ((query as any)?.isYou) {
    return (
      <Container title="SUS FOTOS">
        <Carrousel>
          {myPhotos?.map((photo) => (
            <div className="flex relative flex-col items-center justify-center gap-5 px-7 sm:px-2" key={photo?.code}>
              <DivCardCarrouselStart className="w-full relative h-96 flex flex-col items-center justify-center" >
                <div className="flex-1 w-full">
                  <ImgCardCarrouselStart className="object-cover w-full h-full" src={photo?.imageUrl} alt={photo?.name} />
                </div>
                <div className="flex items-end justify-between w-full py-4 px-4 ">
                  <DescriptionsCardCarrouselStart className="text-left flex-1">CÓDIGO {photo?.code}</DescriptionsCardCarrouselStart>
                  <button onClick={() => handleShare(photo?.imageUrl)}>
                    <svg width="38" height="39" viewBox="0 0 38 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="19" cy="19.9102" r="18" stroke="#D43037" strokeWidth="2" />
                      <path d="M25.1013 7.91016C22.952 7.91016 21.2025 9.62288 21.2025 11.7283C21.2025 11.9533 21.2262 12.1723 21.2645 12.3867L12.7556 16.5533C12.2033 16.259 11.5704 16.092 10.8987 16.092C8.74942 16.092 7 17.8047 7 19.9102C7 22.0156 8.74942 23.7283 10.8987 23.7283C11.6833 23.7283 12.4131 23.4984 13.0254 23.1062L21.221 27.7393C21.2101 27.8556 21.2025 27.973 21.2025 28.092C21.2025 30.1974 22.952 31.9102 25.1013 31.9102C27.2506 31.9102 29 30.1974 29 28.092C29 25.9865 27.2506 24.2738 25.1013 24.2738C23.8767 24.2738 22.7838 24.8314 22.0684 25.6992L14.4831 21.4112C14.6852 20.9502 14.7975 20.4428 14.7975 19.9102C14.7975 19.2942 14.6443 18.7138 14.3787 18.1982L22.2632 14.3374C22.9749 15.0794 23.9824 15.5465 25.1013 15.5465C27.2506 15.5465 29 13.8338 29 11.7283C29 9.62288 27.2506 7.91016 25.1013 7.91016ZM25.1013 10.092C26.0225 10.092 26.7722 10.8262 26.7722 11.7283C26.7722 12.6305 26.0225 13.3647 25.1013 13.3647C24.1801 13.3647 23.4304 12.6305 23.4304 11.7283C23.4304 10.8262 24.1801 10.092 25.1013 10.092ZM10.8987 18.2738C11.8199 18.2738 12.5696 19.008 12.5696 19.9102C12.5696 20.8123 11.8199 21.5465 10.8987 21.5465C9.97752 21.5465 9.22785 20.8123 9.22785 19.9102C9.22785 19.008 9.97752 18.2738 10.8987 18.2738ZM25.1013 26.4556C26.0225 26.4556 26.7722 27.1898 26.7722 28.092C26.7722 28.9942 26.0225 29.7283 25.1013 29.7283C24.1801 29.7283 23.4304 28.9942 23.4304 28.092C23.4304 27.1898 24.1801 26.4556 25.1013 26.4556Z" fill="#D43037" />
                    </svg>
                  </button>
                </div>
              </DivCardCarrouselStart>
              <div className="w-full my-5">
                <Link to="/photographer/upload"><Button>AGREGAR NUEVA FOTO</Button></Link>
              </div>
            </div>
          ))}
        </Carrousel>
        <Link to="/photographer/start" className="pb-7 -mt-5">
          <p className={`din text-center uppercase underline text-black`} style={{ fontSize: 10 }}>VER MAS FOTOS</p>
        </Link>
      </Container>
    )
  }

  const CardCarrousel = ({ photo, index }: { photo: Photos, index: number }) => (
    <>
      <LazyLoad className="bg-gray-200 rounded-3xl" key={photo?.code} once height={320} offset={[-320, 320]}>
        <DivCardStart className={`w-full ${styles['container-height']} relative flex flex-col items-center justify-center`}>
          <div className="h-5/6 w-full">
            <ImgCardStart className="object-cover w-full h-full" src={photo?.imageUrl} alt={photo?.name} />
          </div>
          <DescriptionCardStart className="py-2 px-2 text-center flex-1 flex items-center justify-center">CÓDIGO {photo?.code}</DescriptionCardStart>
        </DivCardStart>
      </LazyLoad>
      {index === 0 && <ContinueCardStart className={styles.continue}>DESLIZA <span><BottomArrow /></span> PARA VER MÁS FOTOS</ContinueCardStart>}
    </>
  )

  return (
    <Container>
      <article className={styles["container-grid"]}>
        {photos?.map((photo) => (
          <CardCarrousel photo={photo} index={photos.indexOf(photo)} key={photo?.code} />
        ))}
      </article>
    </Container>
  )
}

export default Start